import { c as _c } from "react/compiler-runtime";
import type { RefObject } from "react";
import { CollectionSeized } from "@/entities/IProfile";
import type { CommonSelectItem } from "@/components/utils/select/CommonSelect";
import CommonDropdown from "@/components/utils/select/dropdown/CommonDropdown";
type SelectedType = CollectionSeized | null;
export default function UserPageCollectedFiltersSeized(t0) {
  const $ = _c(5);
  const {
    selected,
    containerRef,
    setSelected
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const labels = {
      [CollectionSeized.SEIZED]: "Seized",
      [CollectionSeized.NOT_SEIZED]: "Not Seized"
    };
    t1 = [{
      label: "All",
      mobileLabel: "All Cards",
      value: null,
      key: "all"
    }, ...Object.values(CollectionSeized).map(seized => ({
      label: labels[seized],
      value: seized,
      key: seized
    }))];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const items = t1;
  let t2;
  if ($[1] !== containerRef || $[2] !== selected || $[3] !== setSelected) {
    t2 = <CommonDropdown items={items} activeItem={selected} filterLabel="Seized" containerRef={containerRef} setSelected={setSelected} />;
    $[1] = containerRef;
    $[2] = selected;
    $[3] = setSelected;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}